<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;">
        <div class="top">
            <div class="left">
                <div class="left-flex">
                    <div class="left-title"><svg-icon class="left-svg" icon-class="搜索用户"></svg-icon>搜索用户</div>
                    <div class="left-subtitle">请输入用户名称或编号</div>
                </div>
            </div>
            <div class="right">
                <el-row :gutter="5" style="margin-top: 1.5rem;margin-bottom: 1rem;">
                    <el-col :span="5">
                        <el-select @change="userSelect" v-model="userInput" @visible-change="selectVisibleChange" filterable :filter-method="userFilter" placeholder="输入用户名称或编号"  :disabled="loading">
                            <el-option
                                    v-for="item in users"
                                    :key="item.id"
                                    :label="item.realName"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row :gutter="5" class="right-row-top">
                    <el-col :span="2" class="title-card-top">用户名称：</el-col>
                    <el-col :span="4" class="user-info-top" v-text="userName"></el-col>
                    <el-col :span="2" class="title-card-top">用户编号：</el-col>
                    <el-col :span="4" class="user-info-top" v-text="userCode"></el-col>
                    <el-col :span="2" class="title-card-top">手机号码：</el-col>
                    <el-col :span="4" class="user-info-top" v-text="userPhone"></el-col>
                </el-row>
                <el-row :gutter="5" class="right-row-top">
                    <el-col :span="2" class="title-card-top">联系人：</el-col>
                    <el-col :span="4" class="user-info-top" v-text="userContactPerson"></el-col>
                    <el-col :span="2" class="title-card-top">用户地址：</el-col>
                    <el-col :span="16" class="user-info-top" v-text="userAddr"></el-col>
                </el-row>
            </div>
        </div>
        <div class="middle">
            <div class="left">
                <div class="left-flex">
                    <div class="left-title"><svg-icon class="left-svg" icon-class="选择充值仪表"></svg-icon>选择充抵仪表</div>
                    <div class="left-subtitle">请选择您要充抵的仪表</div>
                </div>
            </div>
            <div class="right">
                <div class="right-table">
                    <flex>
                        <el-table
                                :data="tableData"
                                height="100%"
                                size="mini"
                                ref="singleTable"
                                v-loading="loading"
                                highlight-current-row
                                @current-change="tableClick"
                                :cell-style="cellStyle"
                                :header-cell-style="headStyle"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="仪表名称"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="code"
                                    label="仪表编号"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="meter_num"
                                    label="表号"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="strname"
                                    label="能源类型"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="balance"
                                    label="当前余额（元）"
                                    :formatter="tableNumberFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="readingTime"
                                    label="抄表时间"
                                    :formatter="tableStringFormat">
                            </el-table-column>
                            <el-table-column
                                    prop="meterConnectionStatus"
                                    label="通信状态">
                                <template slot-scope="scope">
                                    <svg-icon :icon-class="scope.row.meterConnectionStatus ===1 ? 'wifi_green' : 'wifi_red'"></svg-icon>
                                </template>
                            </el-table-column>
                        </el-table>
                    </flex>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="left">
                <div class="left-flex">
                    <div class="left-title"><svg-icon class="left-svg" icon-class="选择金额"></svg-icon>填写金额</div>
                    <div class="left-subtitle">充抵后，您会收到充抵结果，请耐心等待</div>
                </div>
            </div>
            <div class="right">
                <div class="right-flex">
                <el-row :gutter="5" class="right-row-bottom">
                    <el-col :span="3" style="line-height: 3.125rem;" class="title-card">充抵金额</el-col>
                    <el-col :span="4">
                        <el-input v-model="money">
                            <template slot="append">元</template>
                        </el-input>
                    </el-col>
                    <el-col :span="15">
                        <span class="right-row-bottom-text">
                            <i class="el-icon-info"></i>
                            请输入正数金额，充抵会自动向仪表内充入负金额，抵销仪表内的余额。
                        </span>
                    </el-col>
                </el-row>
                <el-row :gutter="5" class="right-row-bottom">
                    <el-col :span="3" class="title-card">付款方式</el-col>
                    <el-col :span="4">
                        <el-radio v-model="payType" border label="cashpay"><svg-icon icon-class="现金"></svg-icon>现金</el-radio>
                    </el-col>
                </el-row>
                <el-row :gutter="5" class="right-row-bottom">
                    <el-col  :offset="8" :span="5">
                        <el-button @click="pay" type="primary" icon="el-icon-check">充抵</el-button>
                    </el-col>
                </el-row>
            </div>
            </div>
        </div>
        <el-dialog
                title="确认充抵信息"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                width="25rem"
                center>
            <el-row :gutter="5">
                <el-col class="title-card" :offset="5" :span="6">用户名称:</el-col>
                <el-col class="user-info" :span="12" v-text="userName"></el-col>
            </el-row>
            <el-row :gutter="5" class="right-row">
                <el-col class="title-card" :offset="5" :span="6">用户编号:</el-col>
                <el-col class="user-info" :span="12" v-text="userCode"></el-col>
            </el-row>
            <el-row :gutter="5" class="right-row">
                <el-col class="title-card" :offset="5" :span="6">仪表名称:</el-col>
                <el-col class="user-info" :span="12" v-text="currentRow.meterName"></el-col>
            </el-row>
            <el-row :gutter="5" class="right-row">
                <el-col class="title-card" :offset="5" :span="6">仪表编号:</el-col>
                <el-col class="user-info" :span="12" v-text="currentRow.meterCode"></el-col>
            </el-row>
            <el-row :gutter="5" class="right-row">
                <el-col class="title-card" :offset="5" :span="6">能耗类型:</el-col>
                <el-col class="user-info" :span="12"><span v-text="currentRow.meterType"></span></el-col>
            </el-row>
            <el-row :gutter="5" class="right-row">
                <el-col class="title-card" :offset="5" :span="6">当前余额:</el-col>
                <el-col class="user-info" :span="12"><span v-text="currentRow.balance"></span> 元</el-col>
            </el-row>
            <el-row :gutter="5" class="right-row">
                <el-col class="title-card" :offset="5" :span="6">抄表时间:</el-col>
                <el-col class="user-info" :span="12"><span v-text="currentRow.readingTime"></span></el-col>
            </el-row>
            <el-row :gutter="5" class="right-row">
                <el-col class="title-card" :offset="5" :span="6">充抵金额:</el-col>
                <el-col class="user-info" :span="12"><span v-text="money"></span> 元</el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogYes" :loading="dialogLoading">充抵</el-button>
              <el-button type="danger" @click="dialogVisible = false">取消</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
  import {getMetersByUser} from '@/api/Meter'
  import {selectUsersByCustomerId} from '@/api/customerUser'
  import {quickRecharge} from '@/api/rechargeRecord'
  import {format} from '@/utils/time'
  import {uuidWithoutLine} from "@/utils/uuid"
  import { WS } from '@/utils/ws'
  import Flex from '@/components/Flex'
  export default {
    name: 'CostNetting',
    components: {
      'flex': Flex
    },
    data() {
      return {
        money:"",
        payType:"cashpay",
        payChannel:"costNetting",
        customerId:this.$store.getters.customerId,
        customerUserId:this.$store.getters.userId,
        userInput:"",
        userId:"",
        userName:"--",
        userCode:"--",
        userAddr:"--",
        userContactPerson:"--",
        userPhone:"--",
        tableData:[],
        users:[],
        allUsers:[],
        currentMeterId:"",
        currentRow:{},
        dialogVisible:false,
        dialogLoading:false,
        refundSubscribe: {},
        loading: false
      }
    },
    mounted() {
      this.selectAllUser()
      // WebSocket订阅
      this.refundTopic()
    },
    destroyed() {
      if (this.refundSubscribe && this.refundSubscribe.connected) {
        this.refundSubscribe.disconnect()
      }
    },
    methods: {
      tableStringFormat(row, column, cellValue){   //表格中字符串格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return cellValue
        }
        return "--"
      },
      tableNumberFormat(row, column, cellValue){   //表格中数字格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return cellValue.toFixed(2)
        }
        return "--"
      },
      selectAllUser(){  //查询当前客户的所有用户
        selectUsersByCustomerId(this.customerId).then(response => {
          this.users=response.infoJson
          this.allUsers=response.infoJson   //所有用户信息，用来下拉菜单搜索用户
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '查询用户失败'
          })
        })
      },
      userFilter(val){ //用户下拉菜单搜索
        if (val) { //val存在
          this.users = this.allUsers.filter((item) => {
            if (!!~item.name.indexOf(val) || !!~item.realName.indexOf(val)) {
              return true
            }
          })
        } else { //val为空时，还原数组
          this.users = this.allUsers
        }
      },
      selectVisibleChange(val){ //用户下拉菜单出现/隐藏
        if(val==false){ //下拉菜单收起
          this.users = this.allUsers  //还原数组
        }
      },
      userSelect(){ //用户下拉菜单发生改变
        if(this.users!==null&&this.users!==undefined&&this.users.length!=0){
          this.currentMeterId=""    //选中仪表id置空
          this.currentRow={}    //选中行置空
          for(let i in this.users){ //修改基础信息
            if(this.userInput==this.users[i].id){
              this.userId=this.users[i].id
              if(this.users[i].realName!==undefined&&this.users[i].realName!==null&&this.users[i].realName!==""){
                this.userName=this.users[i].realName
              }else{
                this.userName="--"
              }
              if(this.users[i].name!==undefined&&this.users[i].name!==null&&this.users[i].name!==""){
                this.userCode=this.users[i].name
              }else{
                this.userCode="--"
              }
              if(this.users[i].address!==undefined&&this.users[i].address!==null&&this.users[i].address!==""){
                this.userAddr=this.users[i].address
              }else{
                this.userAddr="--"
              }
              if(this.users[i].contactPerson!==undefined&&this.users[i].contactPerson!==null&&this.users[i].contactPerson!==""){
                this.userContactPerson=this.users[i].contactPerson
              }else{
                this.userContactPerson="--"
              }
              if(this.users[i].mobile!==undefined&&this.users[i].mobile!==null&&this.users[i].mobile!==""){
                this.userPhone=this.users[i].mobile
              }else{
                this.userPhone="--"
              }
              break
            }
          }
          this.loading = true
          getMetersByUser(this.customerId,this.userInput).then(response => { //查询仪表信息，填充表格
            this.loading = false
            this.tableData=response.infoJson
          }).catch(error => {
            this.loading = false
            this.$message({
              type: 'error',
              message: '仪表信息查询失败'
            })
          })
        }
      },
      tableClick(row){ //选中表格某一行,赋值当前仪表id和当前行
        if(row!==null&&row!==undefined){
          if(row.id!==null&&row.id!==undefined&&row.id!==""){
            this.currentMeterId=row.id
          }else{
            this.currentMeterId=""
          }
          if(row.meterConnectionStatus!==null&&row.meterConnectionStatus!==undefined&&row.meterConnectionStatus!==""){
            if(row.meterConnectionStatus==1){
              this.currentRow["meterConnectionStatus"]=true
            }else if(row.meterConnectionStatus==0){
              this.currentRow["meterConnectionStatus"]=false
            }
          }else{
            this.currentRow["meterConnectionStatus"]=false
          }
          if(row.code!==null&&row.code!==undefined&&row.code!==""){
            this.currentRow["meterCode"]=row.code
          }else{
            this.currentRow["meterCode"]="--"
          }
          if(row.name!==null&&row.name!==undefined&&row.name!==""){
            this.currentRow["meterName"]=row.name
          }else{
            this.currentRow["meterName"]="--"
          }
          if(row.balance!==null&&row.balance!==undefined&&row.balance!==""){
            this.currentRow["balance"]=row.balance.toFixed(2)
          }else{
            this.currentRow["balance"]="--"
          }
          if(row.readingTime!==null&&row.readingTime!==undefined&&row.readingTime!==""){
            this.currentRow["readingTime"]=format(row.readingTime,"YYYY-MM-DD HH:mm:ss")
          }else{
            this.currentRow["readingTime"]="--"
          }
          if(row.strname!==null&&row.strname!==undefined&&row.strname!==""){
            this.currentRow["meterType"]=row.strname
          }else{
            this.currentRow["meterType"]="--"
          }
        }else{
          this.currentMeterId=""
        }
      },
      dialogYes(){  //弹出框确定
        this.dialogLoading=true
        let tradeNo=uuidWithoutLine()
        let commandId=uuidWithoutLine()
        quickRecharge(tradeNo,commandId,this.currentMeterId,"-"+this.money,this.payType,this.payChannel,this.customerId,this.customerUserId,this.userId).then(response => {
          if(response.code==200){
            //记录操作id
            this.$store.getters.refundUUID[commandId]=commandId
            this.$message({
              message: '充抵中，请稍候'
            })
          }else{
            this.$message({
              type: 'error',
              message:  response.message
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '充抵失败'
          })
        })
        /*this.currentMeterId=""    //选中仪表id置空
        this.currentRow={}    //选中行置空
        this.$refs.singleTable.setCurrentRow()  //取消表格选中*/
        this.dialogVisible = false
      },
      cellStyle({row, column, rowIndex, columnIndex}){  //单元格样式
        return "text-align: center;"
      },
      headStyle({row, rowIndex}){  //表头样式
        return "text-align: center;"
      },
      pay() {   //点击充抵
        if(this.currentMeterId===null||this.currentMeterId===undefined||this.currentMeterId===""){
          this.$message({
            type: 'error',
            message: '请选择充抵仪表'
          })
          return
        }
        let reg=/^([0-9]+|[0-9]{1,3}(,[0-9]{3})*)(.[0-9]{1,2})?$/;
        if(!reg.test(this.money)){
          this.$message({
            type: 'error',
            message: '请输入合理的充抵金额'
          })
          return
        }else if(parseFloat(this.money)===0){
          this.$message({
            type: 'error',
            message: '请输入合理的充抵金额'
          })
          return
        }
        if(this.currentRow["meterConnectionStatus"]==false){    //判断通讯状态
          this.$message({
            type: 'error',
            message: '该仪表通信中断，无法充抵'
          })
          return
        }
        this.dialogVisible=true
        this.dialogLoading=false
      },
      /**
       * 订阅
       */
      refundTopic() {
        this.refundSubscribe = new WS();
        this.refundSubscribe.connect(res => {
          this.refundSubscribe.subscribe("/topic/refund/" + this.$store.getters.userId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
            let message = null
            if (val !== null && val !== undefined && val.body !== null && val.body !== undefined) {
              message = JSON.parse(val.body)
            }
            if (message !== null && message !== undefined && message.uuid !== null && message.uuid !== undefined && this.$store.getters.refundUUID[message.uuid] == message.uuid) {
              delete this.$store.getters.refundUUID[message.uuid]   //删除操作id
              let result = message.result
              let infoMessage = message.message
              if (result !== null && result !== undefined) {
                //整理数据
                let rechargeTime = "--"
                let userName = "--"
                let userCode = "--"
                let address = "--"
                let meterName = "--"
                let meterCode = "--"
                let meterNum = "--"
                let rechargeAmount = "--"
                let rechargeChannel = "--"
                let rechargeType = "--"
                let balance = "--"
                let preBalance = "--"
                let status = "--"
                let operateName = "--"
                let tradeNo = result.id
                if (result.string_time !== null && result.string_time !== undefined && result.string_time !== "") {
                  rechargeTime = result.string_time
                }
                if (result.customer_user_name !== null && result.customer_user_name !== undefined && result.customer_user_name !== "") {
                  userName = result.customer_user_name
                }
                if (result.customer_user_code !== null && result.customer_user_code !== undefined && result.customer_user_code !== "") {
                  userCode = result.customer_user_code
                }
                if (result.address !== null && result.address !== undefined && result.address !== "") {
                  address = result.address
                }
                if (result.meter_name !== null && result.meter_name !== undefined && result.meter_name !== "") {
                  meterName = result.meter_name
                }
                if (result.meter_code !== null && result.meter_code !== undefined && result.meter_code !== "") {
                  meterCode = result.meter_code
                }
                if (result.meter_num !== null && result.meter_num !== undefined && result.meter_num !== "") {
                  meterNum = result.meter_num
                }
                if (result.recharge_amount !== null && result.recharge_amount !== undefined && result.recharge_amount !== "") {
                  rechargeAmount = result.recharge_amount.toFixed(2)
                }
                if (result.channel_name !== null && result.channel_name !== undefined && result.channel_name !== "") {
                  rechargeChannel = result.channel_name
                }
                if (result.type_name !== null && result.type_name !== undefined && result.type_name !== "") {
                  rechargeType = result.type_name
                }
                if (result.balance !== null && result.balance !== undefined && result.balance !== "") {
                  balance = result.balance.toFixed(2)
                }
                if (result.pre_balance !== null && result.pre_balance !== undefined && result.pre_balance !== "") {
                  preBalance = result.pre_balance.toFixed(2)
                }
                if (result.status !== null && result.status !== undefined && result.status !== "") {
                  if (result.status == 0) {
                    status = "支付中，通讯链路异常，" + infoMessage
                    return
                  } else if (result.status == 1 || result.status == 5) {
                    status = "充抵中"
                    return
                  } else if (result.status == 2) {
                    status = "充抵成功"
                    // 当前选中用户为回调用户时，重新查询仪表信息
                    if (result.customer_user_id === this.userInput) {
                      this.loading = true
                      getMetersByUser(this.customerId,this.userInput).then(response => {
                        this.loading = false
                        this.tableData = response.infoJson
                      }).catch(error => {
                        this.loading = false
                      })
                    }
                  } else if (result.status == 3) {
                    status = "支付失败"
                  } else if (result.status == 4) {
                    status = "充抵失败，原因：" + infoMessage
                  }
                }
                if (result.operate_name !== null && result.operate_name !== undefined && result.operate_name !== "") {
                  operateName = result.operate_name
                }
                //设置通知内容、类型
                let notifyType = "success"
                let notifyMessage = ""
                if (result.status == 2) {   //充值成功
                  notifyMessage = "尊敬的" + userName + "(" + userCode + ")" + "，您的仪表" + meterName + "(" + meterCode + ")" + status + "，充抵金额" + rechargeAmount + "元。"
                } else {
                  notifyType = "error"
                  notifyMessage = "尊敬的" + userName + "(" + userCode + ")" + "，您的仪表" + meterName + "(" + meterCode + ")" + status + "，请在稍后核对仪表余额。"
                }
                //整理充值记录单内容
                let content = `<style type='text/css'>
                            .subtitle {text-align: center;font-size: 13px;font-weight: 600;margin-bottom: 2px;}
                            .title {text-align: center;font-size: 13px;margin-bottom: 10px;height: 23px;border-bottom: 1px dashed #999999;}
                            .content-bottom {border-top: 1px dashed #999999;margin-top:2px;}
                            .content-bottom-font{font-size: 9px;color: #464646;text-align: center;margin-top :7px;}
                            .name {width: 48%;float: left;text-align: right;padding-right: 2%;color: #464646;font-size: 10px;line-height: 15px;}
                            .value {width: 50%;float: left;font-size: 11px;line-height: 15px;white-space: normal;word-break: break-all;word-wrap: break-word;}
                         </style>
                         <div class='print'>
                         <div class='subtitle'>AcuBill网络预付费系统</div>
                            <div class='title'>充抵记录单</div>
                            <div><div class='name'>充抵单号:</div><div class='value'>` + tradeNo + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充抵时间:</div><div class='value'>` + rechargeTime + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户名称:</div><div class='value'>` + userName + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户编号:</div><div class='value'>` + userCode + `</div><br style='clear:both;'></div>
                            <div><div class='name'>用户地址:</div><div class='value'>` + address + `</div><br style='clear:both;'></div>
                            <div><div class='name'>仪表名称:</div><div class='value'>` + meterName + `</div><br style='clear:both;'></div>
                            <div><div class='name'>仪表编号:</div><div class='value'>` + meterCode + `</div><br style='clear:both;'></div>
                            <div><div class='name'>表号:</div><div class='value'>` + meterNum + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充抵金额(元):</div><div class='value'>` + rechargeAmount + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充抵渠道:</div><div class='value'>` + rechargeChannel + `</div><br style='clear:both;'></div>
                            <div><div class='name'>付款方式:</div><div class='value'>` + rechargeType + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充抵前余额(元):</div><div class='value'>` + preBalance + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充抵后余额(元):</div><div class='value'>` + balance + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充抵状态:</div><div class='value'>` + status + `</div><br style='clear:both;'></div>
                            <div><div class='name'>操作人:</div><div class='value'>` + operateName + `</div><br style='clear:both;'></div>
                            <div class='content-bottom'><div class='content-bottom-font'>请您妥善保管</div></div>
                         </div>`
                //通知
                this.$notify({
                  title: status,
                  type: notifyType,
                  dangerouslyUseHTMLString: true,
                  duration: 0,
                  message: this.$createElement("div", null, [
                    this.$createElement("div", {
                      style: {
                        "margin-bottom": "5px",
                        "word-break": "break-all"
                      }
                    }, notifyMessage),
                    result.status === 2 ? this.$createElement("button", {
                      on: {
                        click: function () {
                          //打印账单
                          let newWindow = window.open("about:blank")
                          newWindow.document.write(content)
                          newWindow.print();
                          newWindow.close();
                        }
                      },
                      attrs: {
                        class: "el-button el-button--primary"
                      }
                    }, "打印凭条") : null,
                    result.status === 2 ? this.$createElement("button", {
                      on: {
                        click: function () {
                          if (result.email !== null && result.email !== undefined && result.email !== "") {
                            sendMail(result.email, result.customer_name, "充抵记录单", content, null).then(response => {
                              if (response.code == 200) {
                                this.$message({
                                  type: 'success',
                                  message: '邮件发送成功'
                                })
                              } else {
                                this.$message({
                                  type: 'error',
                                  message: '邮件发送失败'
                                })
                              }
                            }).catch(error => {
                              this.$message({
                                type: 'error',
                                message: '邮件发送失败'
                              })
                            })
                          } else {
                            this.$message({
                              type: 'error',
                              message: '该用户未设置电子邮箱'
                            })
                          }
                        }
                      },
                      attrs: {
                        class: "el-button el-button--primary"
                      }
                    }, "发送邮件") : null
                  ])
                })
              }
            }
          })
          }, err => {

          })
      }
    }
  }
</script>

<style scoped>
    .top{
        position: absolute;
        left: 0;
        top: 2%;
        bottom: 0;
        width:100%;
        height:25%;
        background-color: #ffffff;
        border-radius: 4px;
    }
    .middle{
        position: absolute;
        left: 0;
        top: 29%;
        bottom: 0;
        width:100%;
        height:30%;
        background-color: #ffffff;
        border-radius: 4px;
    }
    .bottom{
        position: absolute;
        left: 0;
        top: 61%;
        bottom: 0;
        width:100%;
        height:35%;
        background-color: #ffffff;
        border-radius: 4px;
    }
    .left{
        position: absolute;
        left: 0;
        right: 70%;
        top: 0;
        bottom: 0;
        width:30%;
        height:100%;
    }
    .right{
        position: absolute;
        left: 30%;
        right: 0;
        top: 0;
        bottom: 0;
        width:70%;
        height:100%;
    }
    .right-flex{
        display: flex;
        flex-direction:column;
        height:100%;
        width: 100%;
        justify-content: center;
    }
    .right-row-bottom{
        margin-bottom: 25px;
    }
    .right-row{
        margin-top: 5px;
    }
    .right-row-top{
        margin-top: 0;
    }
    .left-title{
        font-size: 22px;
        font-weight: 600;
        text-align: center;
    }
    .left-subtitle{
        color: #6A6A6A;
        text-align: center;
        margin-top:5px;
        font-size:14px;
        -webkit-transform: scale(0.95);
    }
    .left-flex{
        display: flex;
        flex-direction:column;
        height:100%;
        width: 100%;
        align-items:center;
        justify-content: center;
    }
    .left-svg{
        height:30px;
        width:40px;
    }
    .el-radio{
        width: 90%;
    }
    .title-card{
        line-height: 40px;
        font-weight: normal;
        font-size: 15px;
        color: #6A6A6A;
    }
    .user-info{
        line-height: 40px;
        font-weight: normal;
        font-size: 15px;
        word-break: break-all;
    }
    .title-card-top{
        line-height: 35px;
        font-weight: normal;
        font-size: 15px;
        color: #6A6A6A;
    }
    .user-info-top{
        line-height: 35px;
        font-weight: normal;
        font-size: 15px;
    }
    .right-table{
        position: absolute;
        left: 0;
        right: 0;
        top: 5%;
        bottom: 5%;
        width: 100%;
        height: 90%;
    }
    .right-row-bottom-text{
        line-height: 50px;
        color: #6A6A6A;
    }
</style>
